import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import {
  AuthenticationResult,
  AccountInfo,
  InteractionRequiredAuthError,
} from '@azure/msal-browser';
import { STORAGE } from 'src/app/core/enums/storage';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private msalService: MsalService, private router: Router) {}

  isLoggedIn(): boolean {
    return !!this.getActiveAccount();
  }
  async getAccessToken(
    scopes: string[] = ['User.Read']
  ): Promise<string | null> {
    const account = this.msalService.instance.getActiveAccount();
    if (!account) return null;

    try {
      const tokenResponse = await this.msalService.instance.acquireTokenSilent({
        scopes,
        account,
      });

      return tokenResponse.accessToken;
    } catch (error) {
      console.error(error);
      this.logout();
      return null;
    }
  }

  async getActiveAccount() {
    return await this.msalService.instance.getActiveAccount();
  }

  async handleRedirectCallback(): Promise<void> {
    const result = await this.msalService.instance.handleRedirectPromise();

    if (result?.account) {
      // ✅ Set active account
      this.msalService.instance.setActiveAccount(result.account);

      // Clean URL hash/query after redirect
      if (window.location.pathname === '/dashboard/dashboard') {
        window.history.replaceState({}, document.title, '/dashboard/dashboard');
        // replaces URL without reloading → no loop
      } else {
        // Navigate using Angular router if needed
        this.router.navigate(['/dashboard/dashboard']);
      }
    } else if (this.msalService.instance.getActiveAccount()) {
      // Already logged in (refresh)
      if (!window.location.pathname.startsWith('/dashboard')) {
        this.router.navigate(['/dashboard/dashboard']);
      }
    }
  }

  loginRedirect() {
    this.msalService.loginRedirect({
      scopes: [
        'openid',
        'profile',
        'offline_access',
        'user.read', // if using Graph
      ],
    });
  }

  async logout(): Promise<void> {
    const accounts = this.msalService.instance.getAllAccounts();
    console.log(accounts);
    // Clear active account in memory
    this.msalService.instance.setActiveAccount(null);
    // Logout all accounts in cache
    console.log(accounts);
    if (accounts.length) {
      localStorage.removeItem(STORAGE.USER_PROFILE);
      localStorage.removeItem(STORAGE.CLUSTER_INFO);

      // Redirects to Azure logout for first account (you can loop if needed)
      await this.msalService.logoutRedirect({
        account: accounts[0],
        postLogoutRedirectUri: window.location.origin + '/login',
      });
    } else {
      console.log(`navigating to login`);
      // No account, just navigate to login
      this.router.navigate(['/login']);
    }
  }
}
